export default __webpack_public_path__ + "static/media/sustainability-img-mb@2x.c80239b5.jpg";